import React from "react";
import fetch from './_AdminCustomFetch'
 // Make the collapsed status of the sidebar a context variable
 const sidebarCollapseContext = React.createContext({
    sidebarCollapsed: false,
    toggleSidebar: () => {}          // empty function that gets defined later (by sidebar in our case)
});   // Context so all child components can access this

export default sidebarCollapseContext;